import(/* webpackMode: "eager" */ "/opt/buildhome/repo/frontend/src/app/template.tsx");
